export default __webpack_public_path__ + "images/0x6b175474e89094c44da98b954eedeac495271d0f.png";